export function getBookingState(booking) {
  const products = booking.products.edges

  if (booking.state !== 'booked') return booking.state

  const planDrawingProducts = ['PlanDrawingProduct', 'MeasurementProduct']
  const productsOtherThanPlanDrawing = products.filter(
    ({ node: product }) => !planDrawingProducts.includes(product.__typename)
  )

  if (!productsOtherThanPlanDrawing.length) return booking.state

  const unfinishedProduct = productsOtherThanPlanDrawing.find(({ node: product }) => (product.state === 'waiting_for_input' || product.state === 'booked'))

  return !!unfinishedProduct ? booking.state : 'completed'
}

export function bookingHasPremiumService(booking) {
  return !!booking.premiumService
}
